module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/laptop-768f2465aeab2ddbb51a58b35764e1ac.svg";